<template>
  <ShopifyShipping v-if="SHOPIFYBRANDS.includes(BRAND)"></ShopifyShipping>
  <OpenCartShipping v-else></OpenCartShipping>
</template>

<script>
import { ShopifyShipping, OpenCartShipping } from "./partials";
export default {
  name: "orders",
  components: { ShopifyShipping, OpenCartShipping }
};
</script>
